import { Either } from "src/base/Either";
import { Failure } from "src/base/Failure";
import { NoParam } from "src/base/NoParam";
import { UseCase } from "src/base/UseCase";
import { ISubscriptionRepository } from "../../data/repositories/subscriptionRepository";
import { ICard } from "../model/card";

export class UpdateCard extends UseCase<UpdateCardParams, string> {
  private repository: ISubscriptionRepository;
  constructor(repository: ISubscriptionRepository) {
    super();
    this.repository = repository;
  }

  call(params: UpdateCardParams): Promise<Either<Failure, string>> {
    return this.repository.updateCard(params.card);
  }
}

export class UpdateCardParams {
  card: ICard;
  constructor(card: ICard) {
    this.card = card;
  }
}
